import styled from "styled-components";

export const SignInContainer = styled.div`
  max-width: 50%;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: center;
  gap: 2rem;

  margin: 30px;

  margin: auto;
  @media (max-width: 600px) {
    margin-left: 0px;
  }
`;
